import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { getProjectDissertationInfo } from '@/api/dissertation'

@Component({})
export default class dissertationProjectInfo extends Vue {
    infoData = {}
    numList = []
    id: number = undefined
    showInput = false
    costList = [{ name: '', price: '' }]
    loading = false
    created() {
        this.id = Number(this.$route.query.id)
        if(this.$route.query.type === '1') {
            this.showInput = true
        }
        this.getData()
    }
    buttonShow = menuBtn
    
    addCostItem() {
        this.costList.push({ name: '', price: '' })
    }
    get allCostNum() {
        let num = 0
        if(this.numList.length > 0){
            this.numList.forEach(item => num += item.price ? Number(item.price) : 0)
            return num
        }
        
    }
    async getData() {
        this.loading = true
        await getProjectDissertationInfo(this.id).then((data: any)=>{

        this.infoData = data.projectDissertation
        if(data.projectDissertation.projectDissertationCostList){
            this.numList = data.projectDissertation.projectDissertationCostList
        }
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }
}